import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallerActiveHours } from '@/models/caller';

export const fetchCallerActiveHours = async (phoneNumber: string): Promise<CallerActiveHours> => {
  const response = await queryExecute({
    query: graphql(`
      query CallerActiveHours($phoneNumber: String!) {
        callerActiveHours(phoneNumber: $phoneNumber) {
          callerId
          days
          start
          end
        }
      }
    `),
    variables: {
      phoneNumber,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.callerActiveHours!;
};
